import Vue from 'vue';
import axios from 'axios';
import '../../../filters';
import moment from 'moment';
import vSelect from 'vue-select';

Vue.component('v-select', vSelect);


export default {
  name: 'elementsSearch',
  components: {
    ElementsType: require('../elementsType/elementsType.vue').default,
    TreeSelect: require('../../../customcontrols/selectOfTree.vue').default,
    dateTimePickerComp: require('../../../customcontrols/dateTimePicker.vue').default,
    qrScanner: require('../../../customcontrols/qrScanner.vue').default,
    googleMapElementComp: require('../../../components/maps/gMapElement.vue').default,
    MapComp: require('../../../components/maps/map.vue').default,
    /*switches: require('../../applications/element.vue').default,*/
  },
  props: {

  },
  data: function () {
    return {
      getElementsParameter: '',
      thisPage: null,
      currentTab: 'tab-identity',
      elements: [],
      element: '',
      options: { PageSize: 1000, total: 0, Page: 1, FilterText: '' },
      dataFields: [],
      dataField: '',
      valueContains: '',
      elementProperties: null,
      elementsByProperty: [],
      bQrCodeScan: false,
      barcodeElements: [],
      barcodeElement: '',
      propertiesDialogShow: false,
      elementTypeId: 0,
      elementId: 0,
      elementName: '',
      filterByGPSLocation: false,
      disableSwitch: true,
      bGMapSelect: false,
      bEnableGMap: false,
      gMapData: {
        elementTypeId: -1,
        elementId: -1,
      },
      bHierarchySelect: false,
      bShowTree: false,
      treeData: [],
      treeFilterAux: '',
      HierarchyKey: 0,
      treeOptions: {
        multiple: false,
        checkbox: false,
        checkOnSelect: false,
        autoCheckChildren: false,
        parentSelect: false,
        keyboardNavigation: true,
        deletion: false,
        filter: {
          plainList: true
        }
      },
      treeFilter: '',
      hierarchyLinks: [],
      hierarchyLink: {
        accountingGroup: null,
        commissionDate: '0001-01-01T00:00:00',
        elementId: 0,
        elementTypeId: 0,
        externalFinRef: null,
        groupCategoryDescription: null,
        groupId: 0,
        id: 0,
        linkType: 0,
        locationId: -1,
        parentElementId: 0,
        parentElementTypeId: 0,
        system: false,
        text: '',
        updateStatus: 0,
        HierarchyKey: 0,
        bExpandNodes: false
      },
      elementSelection: '',
    }
  },
  watch: {
    elements: {
      handler: function (val) {
        this.elementSelection = '';
        this.element = '';
      }
    },
    elementSelection: {
      handler: function (val) {
        
        if (val != null)
          this.element = val.id;
        else
          this.element = '';
      }
    },
    element: {
      handler: function (val) {
        this.elementProperties = null;
        this.identityViewProperties();
      }
    },
    dataField: {
      handler: function (val) {
        this.elementsByProperty = [];
      }
    },
    barcodeElements: {
      handler: function (val) {
        this.elements = [];

        for (var i = 0; i < val.length; i++) {
          this.elements.push({
            id: val[i].id,
            label: '#' + val[i].id + ' - ' + val[i].name,
            typeId: val[i].typeId,
            externalRef: val[i].externalRef,
          });
        }

        if (val.length == 1) {
          this.notifyParent(val[0].typeId, val[0].id);
          this.element = val[0].id;
        }
        else
          this.element = '';

        this.saveElementFromBarcode(this.elements);
      }
    },
    filterByGPSLocation: function (value) {
      this.getElements();
    },
    bHierarchySelect: function (value) {
      if (value)
        this.getHierarchyLinks();
      else
        this.hierarchyLinks = [];
    },
    gMapData: {
      handler: function (val) {
        if (val.elementId == -1 || val.elementTypeId == '') {
          this.elementSelection = '';
          this.elements.length = 0;
          return;
        }
          
        this.elementSelection = this.elements.filter(e => e.id == val.elementId)[0];
        
        this.elements.length = 0;
        this.element = val.elementId;
        //this.$refs.selectElementsIdentity.refreshMod(val.elementId);
        this.bGMapSelect = false;        
        this.$root.$emit('selected_element_chosen', this.gMapData);
        
      },
      deep: true
    },
  },
  created() {
    this.$root.$on('element_reset_emit', this.elementReset);
    this.checkForGpsPermissions(true);
    this.thisPage = this;
    this.$material.locale.dateFormat = 'yyyy-MM-dd';
    this.clearHierarchy();
  },
  mounted() {
    this.$watch(
      () => {
        return this.$refs.elementTypeComp.elementType
      },
      (val) => {
        this.bEnableGMap = this.$refs.elementTypeComp.elementTypeNode.gisLayerName == '' ? false : true;
        this.getElements();
        this.getElementTypeProperties();

        this.elementProperties = null;
        this.elementsByProperty = [];

        //this.$refs.selectElementsIdentity.clearSelection();
        //this.$refs.selectDataFields.clearSelection();
        this.valueContains = '';
        this.clearParentData();

        this.bHierarchySelect = false;
        this.hierarchyLinks = [];

        this.gMapData.elementTypeId = this.$refs.elementTypeComp.elementType;
      }
    )
  },
  methods: {
    saveElementFromBarcode(items) {
      if (items && items.length > 0)
        setTimeout(() => this.elementSelection = items[0], 1000);
    },
    elementReset() {
      this.element = [];
      this.elementSelection = null;
      this.gMapData = {
        elementTypeId: this.elementTypeId,
        elementId: -1,
      }
    },
    checkForGpsPermissions(showPopup) {
      navigator.permissions.query({ name: 'geolocation' })
        .then(resp => {
          if (resp.state == 'denied') {
            this.filterByGPSLocation = false;
            if (showPopup)
              this.$alertMsg(this.$t('common.gpsDenied'), 3);
          }
        })
    },
    changeTab(e) {
      this.currentTab = e;

      if (e == 'tab-barcode-search') {
        this.bQrCodeScan = true
      }
    },
    gpsSuccess(pos) {
      let crd = pos.coords;

      this.getElementsParameter = {
        elementTypeId: this.$refs.elementTypeComp.elementType,
        filterByCurrentLocation: this.filterByGPSLocation,
        coordLat: crd.latitude,
        coordLong: crd.longitude,
        coordAccuracy: crd.accuracy,
        listOptions: null,
      };

      this.getElementsRequest();
    },
    gpsError(err) {
      var msg = err.message != '' ? ' - ' + err.message : '';
      this.$alertMsg(this.$t('common.gpsError') + msg);

      this.checkForGpsPermissions();
      
      this.getElementsParameter = {
        elementTypeId: this.$refs.elementTypeComp.elementType,
      };

      this.getElementsRequest();
    },
    getElements() {
      if (this.$refs.elementTypeComp.elementType == '')
        return;
      if (this.filterByGPSLocation)
        navigator.geolocation.getCurrentPosition(this.gpsSuccess, this.gpsError);
      else {
        this.getElementsParameter = {
          elementTypeId: this.$refs.elementTypeComp.elementType,
        };
        this.getElementsRequest();
      }
    },
    getElementsRequest() {
      axios.post('/Element/GetElements', this.getElementsParameter)
        .then(response => {
          if (response.status == 200) {
            this.elements = [];
            //console.log("resp", response)
            for (var i = 0; i < response.data.items.length; i++) {
              this.elements.push({
                id: response.data.items[i].id,
                label: '#' + response.data.items[i].id + ' - ' + response.data.items[i].name,
                typeId: response.data.items[i].typeId,
                externalRef: response.data.items[i].externalRef,
              });
            }

            this.element = '';
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    getHierarchyLinks() {
      if (this.$refs.elementTypeComp.elementType == '')
        return;

      axios.get('/Element/GetHierarchyLinks?elementTypeId=' + this.$refs.elementTypeComp.elementType)
        .then(response => {
          if (response.status == 200) {
            this.hierarchyLinks = response.data;
            //console.log(" this.hierarchyLinks", this.hierarchyLinks)
            this.populateTree();
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    getElementTypeProperties() {
      if (this.$refs.elementTypeComp.elementType == '')
        return;

      axios.get('/Element/GetElementTypeProperties', { params: { elementTypeId: this.$refs.elementTypeComp.elementType } })
        .then(response => {
          if (response.status == 200) {
            this.dataFields = [];

            for (var i = 0; i < response.data.items.length; i++) {
              this.dataFields.push({
                id: response.data.items[i].value,
                label: response.data.items[i].text,
                selected: response.data.items[i].selected,
                group: response.data.items[i].group,
              });
            }

            this.dataField = '';
            this.valueContains = '';
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    identityViewProperties() {
      if (!this.element || this.element === '') {
        this.notifyParent(0, 0);
        //this.$alertMsg('Please select Element');
        return;
      }
      if (this.elements != null && this.elements.length > 0 && this.element != null && this.element != '')
        this.notifyParent(this.elements.filter(a => a.id == this.element)[0].typeId, this.element);
    },
    attributeViewProperties(typeId, id) {
      this.notifyParent(typeId, id);
    },
    searchElements() {
      if (this.$refs.elementTypeComp.elementType == '' || this.$refs.elementTypeComp.elementType == null || this.dataField == '' || this.dataField == null || this.valueContains == '' || this.valueContains == null)
        return;

      axios.get('/Element/GetElementsByProperty', {
        params: {
          elementTypeId: this.$refs.elementTypeComp.elementType,
          propertyId: this.dataField,
          value: this.valueContains,
          pageSize: this.options.PageSize,
          page: this.options.Page
        }
      })
        .then(response => {
          if (response.status == 200) {
            this.elementsByProperty = response.data.items;
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    fillList(list) {
      var selectList = [];

      for (var i = 0; i < list.length; i++) {
        selectList.push({
          id: list[i].value,
          label: list[i].text,
          group: list[i].group,
          selected: list[i].selected,
        });
      }

      return selectList;
    },
    onItemSelected(group, rowIndex, item) {
      for (var i = 0; i < this.elementProperties.properties['' + group + ''][rowIndex].value.length; i++) {
        this.elementProperties.properties['' + group + ''][rowIndex].value[i].selected = false;

        if (this.elementProperties.properties['' + group + ''][rowIndex].value[i].value == item.id)
          this.elementProperties.properties['' + group + ''][rowIndex].value[i].selected = true;
      }
    },
    notifyParent(elementTypeId, elementId) {
      this.$emit('notifyParent', elementTypeId, elementId);
    },
    clearParentData() {
      this.$emit('clearParentData');
    },
    searchTreeData() {
      this.treeFilter = this.treeFilterAux;
    },
    onNodeSelected(node) {
      if (node.children.length > 0)
        return;

      this.element = node.data.elementId;
      this.elementSelection = {
        externalRef: null,
        id: node.data.elementId,
        label: node.data.text,
        typeId: node.data.elementTypeId
      };
        node.data.text;
      //this.$refs.selectElementsIdentity.refreshMod(node.data.elementId);
      this.bHierarchySelect = false;
    },
    onNodeChecked(node) {
      /*node.states.expanded = true;
      var tree = this.$refs.tree;
      this.iSelectedCount++;
      if (node.children.length === 0) {
        this.hierarchyLink = node.data;
        this.element = this.elements.filter(item => item.id === node.data.elementId)[0];
        this.bShowTree = false;
        this.bHierarchySelect = false;
      }*/
    },
    onNodeUnchecked(node) {
      node.states.expanded = true;
      var tree = this.$refs.tree;
      this.iSelectedCount--;
    },
    getNodeImage(id) {
      var elementType = this.$refs.elementTypeComp.elementTypes.filter(t => t.id == id)[0];
      return elementType ? elementType.imageWeb : '';
    },
    getUniqueId() {
      return this.iCurrentCount++;
    },
    populateTree() {
      this.treeOptions = {
        multiple: false,
        checkbox: false,
        checkOnSelect: false,
        autoCheckChildren: false,
        parentSelect: false,
        keyboardNavigation: true,
        deletion: false,
        filter: {
          plainList: false
        }
      };
      this.iCurrentCount = 0;
      this.treeData = [];
      this.hierarchyLinks.forEach(item => {
        this.treeData.push(this.createNodeTree(item));
      });
      this.bShowTree = true;
      this.HierarchyKey++;
    },
    createNodeTree(assetNode) {
      var node = {
        id: this.getUniqueId(),
        text: assetNode.Name,
        data: {
          id: this.getUniqueId(),
          elementId: assetNode.ElementId,
          elementTypeId: assetNode.ElementTypeId
        },
        children: [],
        state: {
          selected: false,
          selectable: true,
          checked: false,
          expanded: this.bExpandNodes,
          disabled: false,
          visible: true,
          indeterminate: false,
          matched: false,
          editable: true,
          dragging: false,
          draggable: true,
          dropable: true
        }
      };
      assetNode.Children.forEach(item => {
        node.children.push(this.createNodeTree(item));
      });
      return node;
    },
    clearHierarchy() {
      this.hierarchyLink = {
        accountingGroup: null,
        commissionDate: '0001-01-01T00:00:00',
        elementId: 0,
        elementTypeId: 0,
        externalFinRef: null,
        groupCategoryDescription: null,
        groupId: 0,
        id: 0,
        linkType: 0,
        locationId: -1,
        parentElementId: 0,
        parentElementTypeId: 0,
        system: false,
        text: '',
        updateStatus: 0
      };
      this.bShowTree = true;
      this.treeFilter = '';
      this.treeFilterAux = '';
    },
  },
}
